import { Spinner } from '@pm/ui';

export const LoadingPage = ({
  classOverride,
  message,
}: {
  classOverride?: string;
  message?: string;
}) => (
  <div className={classOverride ?? 'flex h-screen w-full flex-col'}>
    <div className="flex-1" />
    <div className="w-full text-center">
      <Spinner />

      {message && <div className="mt-6">{message}</div>}
    </div>
    <div className="flex-1" />
  </div>
);
